// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type PageUserNavFragment = {
  __typename?: "User";
  id: string;
  demo: boolean;
  permittedToReviewChangelog: boolean;
  avatarUrl?: string | null;
  fullname?: string | null;
};

export const PageUserNavFragmentDoc = gql`
  fragment PageUserNav on User {
    id
    demo
    permittedToReviewChangelog
    avatarUrl
    fullname
  }
`;
